// import { useEffect, useState } from "react";
// import { getUnreadCount } from "../../../api/system/notifications";
// import { socket } from "../../../utils/socket";

// export default function NotificationBell({ onClick }) {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     let mounted = true;

//     const load = async () => {
//       const n = await getUnreadCount();
//       if (mounted) setCount(n);
//     };

//     // 1️⃣ Load lần đầu
//     load();

//     // 2️⃣ Lắng nghe realtime từ WebSocket
//     socket.on("notification:new", () => {
//       load(); // cập nhật ngay lập tức
//     });

//     // 3️⃣ Lắng nghe refresh chủ động từ NotificationsPage
//     const handleRefresh = () => load();
//     window.addEventListener("refresh-notification-count", handleRefresh);

//     // 4️⃣ Dự phòng interval mỗi 60s
//     const t = setInterval(load, 60000);

//     return () => {
//       mounted = false;
//       clearInterval(t);
//       window.removeEventListener("refresh-notification-count", handleRefresh);
//       socket.off("notification:new");
//     };
//   }, []);

//   return (
//     <button
//       onClick={onClick}
//       className="relative inline-flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100"
//       title="Thông báo"
//     >
//       {/* icon chuông */}
//       <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//         <path strokeWidth="1.5" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75V9a6 6 0 10-12 0v.75a8.967 8.967 0 01-2.311 6.022c1.78.64 3.591 1.085 5.454 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
//       </svg>

//       {count > 0 && (
//         <span className="absolute -top-1 -right-1 min-w-5 h-5 px-1 rounded-full bg-red-600 text-white text-xs flex items-center justify-center">
//           {count > 99 ? "99+" : count}
//         </span>
//       )}
//     </button>
//   );
// }





import { useEffect, useState } from "react";
import { getUnreadCount } from "../../../api/system/notifications";
import { socket } from "../../../utils/socket";

export default function NotificationBell({ onClick }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let mounted = true;
    let lastRequestId = 0;          // ⭐ chống ghi đè kết quả cũ
    let reloadTimer = null;         // ⭐ debounce realtime

    const load = async () => {
      const requestId = ++lastRequestId;

      try {
        const n = await getUnreadCount();
        const total = typeof n === "number" ? n : n?.count ?? 0;

        // ⭐ Chỉ update khi là request mới nhất
        if (mounted && requestId === lastRequestId) {
          setCount(total);
        }
      } catch (err) {
        console.error("❌ Load unread count failed:", err);
      }
    };

    // 1️⃣ Load lần đầu
    load();

    // 2️⃣ Realtime từ WebSocket (debounce 120ms)
    socket.on("notification:new", () => {
      clearTimeout(reloadTimer);
      reloadTimer = setTimeout(load, 120);
    });

    // 3️⃣ Lắng nghe refresh chủ động từ trang NotificationsPage
    const handleRefresh = () => load();
    window.addEventListener("refresh-notification-count", handleRefresh);

    // 4️⃣ Auto refresh mỗi 60s (dự phòng)
    const interval = setInterval(load, 60000);

    return () => {
      mounted = false;
      clearInterval(interval);
      window.removeEventListener("refresh-notification-count", handleRefresh);
      socket.off("notification:new");
    };
  }, []);

  return (
    <button
      onClick={onClick}
      className="relative inline-flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100"
      title="Thông báo"
    >
      {/* Icon Chuông */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-6 h-6 text-gray-700"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeWidth="1.5"
          d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75V9a6 6 0 10-12 0v.75a8.967 8.967 0 01-2.311 6.022c1.78.64 3.591 1.085 5.454 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
        />
      </svg>

      {/* Badge số lượng */}
      {count > 0 && (
        <span className="absolute -top-1 -right-1 min-w-5 h-5 px-1 rounded-full bg-red-600 text-white text-xs flex items-center justify-center">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
}
